import z from 'zod';

// Experiment keys and values end up in a `petri_ovr` cookie, so they are
// limited to cookie-safe characters.
const httpExperimentTokenRegex = /^[\w.-]+$/;

const httpExperimentTokenSchema = z.string().regex(httpExperimentTokenRegex);

export const httpExperimentsSchema = z.record(
  httpExperimentTokenSchema,
  z.union([z.boolean(), httpExperimentTokenSchema])
);

export function createPetriOverridesCookie(
  experiments: Record<string, boolean | string> | undefined
): Readonly<Record<string, string>> | undefined {
  const experimentsStrings = Object.entries(experiments ?? {}).map(
    ([key, value]) => `${key}#${value}`
  );
  if (experimentsStrings.length === 0) {
    return undefined;
  }
  return { petri_ovr: experimentsStrings.join('|') };
}
